//'vue/dist/vue.esm-bundler' 'vue/dist/vue.esm-bundler.js'
import { createApp } from 'vue';
import { reactive } from 'vue';

import router from './router';
import store from './core/store';
import App from './App.vue';

// Импортируем форматтер
import { dateFilter, primeVueRU } from './core/utils';

import Tag from 'primevue/tag';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Checkbox from 'primevue/checkbox';
import TreeTable from 'primevue/treetable';

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
// import Dropdown from './Dropdown.vue';
import Dropdown from 'primevue/dropdown';
import Fieldset from 'primevue/fieldset';
import FileUpload from 'primevue/fileupload';
import FloatLabel from 'primevue/floatlabel';
import InlineMessage from 'primevue/inlinemessage';
import InputMask from 'primevue/inputmask'; 
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import ScrollPanel from 'primevue/scrollpanel';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import Panel from 'primevue/panel';
import Password from 'primevue/password';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
import RadioButton from 'primevue/radiobutton';
import Ripple from 'primevue/ripple';
import SelectButton from 'primevue/selectbutton';
import Slider from 'primevue/slider';
import Sidebar from 'primevue/sidebar';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ToggleButton from 'primevue/togglebutton';
import Toolbar from 'primevue/toolbar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Tooltip from 'primevue/tooltip';
import ColorPicker from 'primevue/colorpicker';
import OverlayPanel from 'primevue/overlaypanel';
import AppInputStyleSwitch from './core/layout/AppInputStyleSwitch';
import PrimeVue from 'primevue/config';
 import ContextMenu from 'primevue/contextmenu'; 
import { FilterService } from 'primevue/api';

//import Editor from 'primevue/editor';
// import DataView from 'primevue/dataview'; // 
// import DataViewLayoutOptions from 'primevue/dataviewlayoutoptions'; // 
// import AutoComplete from 'primevue/autocomplete'; // 
// import Accordion from 'primevue/accordion'; // 
// import AccordionTab from 'primevue/accordiontab'; // 
// import Carousel from 'primevue/carousel'; // 
// import Tree from 'primevue/tree'; // 
// import SplitButton from 'primevue/splitbutton'; // 
// import Steps from 'primevue/steps'; // 
// import TabMenu from 'primevue/tabmenu'; // 
// import PickList from 'primevue/picklist'; // 
// import Listbox from 'primevue/listbox'; // 
// import Menu from 'primevue/menu'; // 
// import Menubar from 'primevue/menubar'; // 
// import PanelMenu from 'primevue/panelmenu'; // 
// import Paginator from 'primevue/paginator'; //
// import Inplace from 'primevue/inplace'; // 

import {
  ErrorDialog,
  ViewCustomRow,
  CustomDataTable,
  ExpandedDataTable,
  VerticalDataTable,
  CustomDataTableEdit,
  ViewCustomData,
  CustomCalendar,
  CustomColor,
} from 'cdisoft-library';

import 'primevue/resources/primevue.min.css';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';

import './core/assets/layout/layout.scss';
import './core/assets/layout/flags/flags.css';


const app = createApp(App);
app.config.globalProperties.$appState = reactive({ inputStyle: 'outlined' });
app.config.globalProperties.$primevue = reactive({ ripple: true });
FilterService.register('dateIsGMT', dateFilter);

// Конфигурация PrimeVue с кастомными иконками для Toast
const primeVueConfig = {
  ...primeVueRU,
  ripple: true,
  locale: {
    ...primeVueRU.locale,
    // Кастомные иконки для Toast
    startTransition: 'pi pi-arrow-right',
    endTransition: 'pi pi-arrow-left',
  },
};

app.use(PrimeVue, primeVueConfig);
app.use(ToastService);

app.use(router);
app.use(store);

app.component('AppInputStyleSwitch', AppInputStyleSwitch);

app.directive('tooltip', Tooltip);
app.directive('ripple', Ripple);

app.component('ErrorDialog', ErrorDialog);
app.component('CustomDataTable', CustomDataTable);
app.component('CustomDataTableEdit', CustomDataTableEdit);
app.component('VerticalDataTable', VerticalDataTable);
app.component('ViewCustomData', ViewCustomData);
app.component('ExpandedDataTable', ExpandedDataTable);
app.component('ViewCustomRow', ViewCustomRow);
app.component('CustomCalendar', CustomCalendar);
app.component('CustomColor', CustomColor);

app.component('Divider', Divider);
app.component('Tag', Tag);
app.component('ScrollPanel', ScrollPanel);
app.component('Button', Button);
app.component('Calendar', Calendar);
app.component('Checkbox', Checkbox);
app.component('TreeTable', TreeTable);

app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('HeaderRow', Row);
app.component('ColumnGroup', ColumnGroup);
app.component('Dialog', Dialog);
app.component('Dropdown', Dropdown);
app.component('Fieldset', Fieldset);
app.component('FileUpload', FileUpload);
app.component('FloatLabel', FloatLabel);
app.component('InlineMessage', InlineMessage);

app.component('InputMask', InputMask); 
app.component('InputNumber', InputNumber);
app.component('InputSwitch', InputSwitch);
app.component('InputText', InputText);
app.component('Message', Message);
app.component('MultiSelect', MultiSelect);
app.component('Panel', Panel);
app.component('Password', Password);
app.component('ProgressBar', ProgressBar);
app.component('ProgressSpinner', ProgressSpinner);
app.component('RadioButton', RadioButton);
app.component('SelectButton', SelectButton);
app.component('Slider', Slider);
app.component('Sidebar', Sidebar);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Textarea', Textarea);
app.component('ToggleButton', ToggleButton);
app.component('Toast', Toast);
app.component('Toolbar', Toolbar);
app.component('ColorPicker', ColorPicker);
app.component('OverlayPanel', OverlayPanel);
app.component('ContextMenu', ContextMenu);  
//app.component('Editor', Editor);
// app.component('Accordion', Accordion); // 
// app.component('AccordionTab', AccordionTab); //
// app.component('AutoComplete', AutoComplete); //
// app.component('Carousel', Carousel); //

// app.component('DataView', DataView); // 
// app.component('DataViewLayoutOptions', DataViewLayoutOptions); // 
// app.component('Tree', Tree); //
// app.component('SplitButton', SplitButton); // 
// app.component('Steps', Steps); // 
// app.component('TabMenu', TabMenu); // 
// app.component('Listbox', Listbox); // 
// app.component('Menu', Menu); // 
// app.component('Menubar', Menubar); // 
// app.component('Paginator', Paginator); // 
// app.component('PickList', PickList); // 
// app.component('PanelMenu', PanelMenu); //
// app.component('Inplace', Inplace); // 
app.mount('#app');